import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TutorBankInfo from "./tutorBankInfo";
import axios from "axios";
import Reason from "./Reason";
import RefreshIcon from "@mui/icons-material/Refresh";
import CircularProgress from '@mui/material/CircularProgress';

// function createData(name, calories, fat, carbs, protein) {
//   return { name, calories, fat, carbs, protein };
// }

export default function DenseTable({ paymentApprovalAr, initialCircularBar, setInitialCircularBar, setUpdated, updated }) {
  const [visibleCircularbar, setVisibleCircularbar] = useState(false);
  const [paymentVisibleCircularbar, setPaymentVisibleCircularbar] = useState(false);
  const [pandetailsReasonDialog, setPandetailsReasonDialog] = useState(false);
  const [pandetailsReason, setPandetailsReason] = useState();
  const [pandetails, setPandetails] = useState(false);
  const [paymentdetailsReasonDialog, setPaymentdetailsReasonDialog] = useState(false);
  const [paymentdetailsReason, setPaymentdetailsReason] = useState();
  const [paymentdetails, setPaymentdetails] = useState(false);
  const [currTutor, setCurrTutor] = useState();

  const updatePaymentDetailsStatusAccept = async (
    tutorId,
    accountNo,
    upi_id,
    ifsc
  ) => {
    const updatePaymentDet1 = await axios.put(
      // `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/setTutorPaymentDetailsStatus/${tutorId}`,
      `https://testapis4.el.r.appspot.com/api/tutorweb/setTutorPaymentDetailsStatus/${tutorId}`,
      // `http://localhost:8600/api/tutorweb/setTutorPaymentDetailsStatus/${tutorId}`,
      {
        // const updatePaymentDet1 = await axios.put(
        //   `https://testapis4.el.r.appspot.com/api/tutorweb/setTutorPaymentDetailsStatus/${tutorId}`,
        //   {
        status: "accept",
      }
    );
    if (updatePaymentDet1.data) {
      let tagsAr = updatePaymentDet1.data.tagsAr;


      const updateBankDetails = await axios.put(
        `https://central-device-apis.el.r.appspot.com/api/tutorweb/updateTutorPaymentDetails/${tutorId}`,
        // `https://central-device-apis.el.r.appspot.com/api/tutorweb/updateTutorPaymentDetails/${tutorId}`,
        // `http://localhost:8000/api/tutorweb/updateTutorPaymentDetails/${tutorId}`,

        {
          // const updateBankDetails = await axios.put(
          //   `http://localhost:8800/api/tutorweb/updateTutorPaymentDetails/${tutorId}`,
          //   {
          accountNo: accountNo,
          upi_id: upi_id,
          ifsc: ifsc,
          tutor_status: "active",
          tags: tagsAr,
          device_type: "tp",
        }
      );

      if (updateBankDetails.data) {
        alert(`Bank account details of ${tutorId} is updated!`);
        setUpdated(!updated);
      }
    }
  };

  const updatePanDetailsStatusAccept = async (tutorId , pan) => {
    const updatePaymentDet1 = await axios.put(
      // `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/setTutorPanDetailsStatus/${tutorId}`,
      `https://testapis4.el.r.appspot.com/api/tutorweb/setTutorPanDetailsStatus/${tutorId}`,
      // `http://localhost:8600/api/tutorweb/setTutorPanDetailsStatus/${tutorId}`,
      {
        // const updatePaymentDet1 = await axios.put(
        //   `https://testapis4.el.r.appspot.com/api/tutorweb/setTutorPanDetailsStatus/${tutorId}`,
        //   {
        status: "accept",
        pan: pan
      }
    );
    if (updatePaymentDet1.data) {
      const updateBankDetails = await axios.put(
        // `https://central-device-apis.el.r.appspot.com/api/tutorweb/updateTutorPanDetails/${tutorId}`,
        `https://central-device-apis.el.r.appspot.com/api/tutorweb/updateTutorPanDetails/${tutorId}`,
        {
          // const updateBankDetails = await axios.put(
          //   `http://localhost:8800/api/tutorweb/updateTutorPanDetails/${tutorId}`,
          //   {
          pan: pan,
        }
      );

      if (updateBankDetails.data) {
        alert(`PAN Card details of ${tutorId} is updated!`);
        setUpdated(!updated);
      }
      // window.location.reload()
    }
  };

  const updatePaymentDetailsStatusReject = async (tutorId, paymentRejectionReason) => {
    setPaymentVisibleCircularbar(true);
    const updatePaymentDet2 = await axios.put(
      // `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/setTutorPaymentDetailsStatus/${tutorId}`,
      `https://testapis4.el.r.appspot.com/api/tutorweb/setTutorPaymentDetailsStatus/${tutorId}`,
      {
        status: "reject",
        paymentRejectionReason
      }
    );
    if (updatePaymentDet2.data) {
      // window.location.reload();
      // alert("Updated");
      setPaymentdetailsReasonDialog(false)
      setPaymentVisibleCircularbar(false);
      alert(`Bank account details of ${tutorId} is rejected!`);
      setUpdated(!updated);
    }
  };

  const updatePanDetailsStatusReject = async (tutorId, panRejectionReason) => {
    setVisibleCircularbar(true);
    const updatePaymentDet2 = await axios.put(
      // `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/setTutorPanDetailsStatus/${tutorId}`,
      `https://testapis4.el.r.appspot.com/api/tutorweb/setTutorPanDetailsStatus/${tutorId}`,
      {
        status:
          paymentApprovalAr?.panDetails_status === "new_checking"
            ? "new_reject"
            : "old_reject",
        panRejectionReason: panRejectionReason,
      }
    );
    if (updatePaymentDet2.data) {
      // window.location.reload();
      // alert("Payment Updated");
      setPandetailsReasonDialog(false);
      setVisibleCircularbar(false);
      alert(`PAN Card details of ${tutorId} is rejected!`);
      setUpdated(!updated);
    }
  };


  const handlePanReject = (tutorId) => {
    setCurrTutor(tutorId);
    setPandetailsReasonDialog(true);
  };

  const handlePaymentReject = (tutorId) => {
    setCurrTutor(tutorId);
    setPaymentdetailsReasonDialog(true);
  };
  useEffect(() => {

    if (paymentdetails) {
      updatePaymentDetailsStatusReject(currTutor, paymentdetailsReason.target.value);
    }
  }, [paymentdetails]);

  useEffect(() => {
    if (pandetails) {
      updatePanDetailsStatusReject(currTutor, pandetailsReason.target.value);
    }


  }, [pandetails]);

  const rows = [];
  const pay1 = paymentApprovalAr?.map((el2) => {
    rows.push(el2);
  });

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>

              Doer's Name</TableCell>
            <TableCell align="right">Doer's Id</TableCell>
            <TableCell align="left"> {initialCircularBar ? <CircularProgress style={{ height: '25px', width: '25px' }} /> : <RefreshIcon fontSize="medium" onClick={() => setUpdated(!updated)} />}</TableCell>
            <TableCell align="right"> </TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={row.tutor_id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.tutor_id}</TableCell>
              <TableCell align="right">
                {row.paymentDetails_status === "new" && (
                  <Button style={{ color: "blue" }}>
                    <TutorBankInfo
                      key={index}
                      paymentInfo={row}
                      rowInfo={row?.paymentDetails_status}
                    />
                  </Button>
                )}
                <br />
                {(row.panDetails_status === "new_checking" ||
                  row.panDetails_status === "old_checking") && (
                    <Button style={{ color: "blue" }}>
                      <TutorBankInfo
                        key={index}
                        paymentInfo={row}
                        rowInfo={row?.panDetails_status}
                      />
                    </Button>
                  )}
              </TableCell>
              <TableCell align="right">
                {row.paymentDetails_status === "new" && (
                  <Button
                    onClick={() =>
                      updatePaymentDetailsStatusAccept(
                        row.tutor_id,
                        row.Bank.acc_no,
                        row.Bank.upi_id,
                        row.Bank.ifsc_code,
                        row.pan
                      )
                    }
                    style={{ color: "green" }}
                  >
                    Accept Account
                  </Button>
                )}
                {(row.panDetails_status === "new_checking" ||
                  row.panDetails_status === "old_checking") && (
                    <Button
                      onClick={() =>
                        updatePanDetailsStatusAccept(
                          row.tutor_id,
                          row.pan
                        )
                      }
                      style={{ color: "green" }}
                    >
                      Accept PanCard
                    </Button>
                  )}
              </TableCell>
              <TableCell align="right">
                {row.paymentDetails_status === "new" && (
                  <Button
                    onClick={() =>
                      handlePaymentReject(row.tutor_id)
                    }
                    style={{ color: "red" }}
                  >
                    Reject Account
                  </Button>
                )}
                {(row.panDetails_status === "new_checking" ||
                  row.panDetails_status === "old_checking") && (
                    <Button onClick={() => handlePanReject(row.tutor_id)} style={{ color: "red" }}>
                      Reject PanCard
                    </Button>
                  )}
                {pandetailsReasonDialog && (
                  <Reason
                    setReason={setPandetails}
                    setReasonVal={setPandetailsReason}
                    setReasonDialog={setPandetailsReasonDialog}
                    reasonDialog={pandetailsReasonDialog}
                    visibleCircularbar={visibleCircularbar}
                  />
                )}

                {paymentdetailsReasonDialog && (
                  <Reason
                    setReason={setPaymentdetails}
                    setReasonVal={setPaymentdetailsReason}
                    setReasonDialog={setPaymentdetailsReasonDialog}
                    reasonDialog={paymentdetailsReasonDialog}
                    visibleCircularbar={paymentVisibleCircularbar}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
